import { Select } from 'gu-ui-kit'
import React from 'react'

const renderSelect = ({
  input,
  meta,
  errorIcon = null,
  helperText = null,
  renderError = (error) => error,
  t = () => {},
  ...rest
}) => {
  const ErrorIcon = errorIcon && meta?.touched && meta?.error ? errorIcon : null

  return (
    <Select
      {...input}
      {...rest}
      disabled={rest.disabled || meta?.submitting}
      helperText={
        meta?.touched && meta?.error ? (
          <>
            {ErrorIcon}
            {t(renderError(meta?.error))}
          </>
        ) : (
          helperText
        )
      }
      error={!!(meta?.touched && meta?.error)}
    />
  )
}

export default renderSelect
